import { useEffect, useState } from 'react'

import { SubmitQuizzWithImageAndOptionsResponse as BLSubmitQuizzWithImageAndOptionsResponse } from './../../../utilities/BL/Zones'


const QuizzWithImageAndOptions = ({ quizz }) => {
    const [selectedOption, setSelectedOption] = useState(null)
    

    // Reiniciar todo al cambiar de pregunta
    useEffect(() => {
        setSelectedOption(null)

        if (quizz.isItemVisible) {            
            const tmpData = sessionStorage.getItem('eudnrlanrbaewq')

            if (!tmpData) {
                return
            }

            const data = JSON.parse(tmpData)
            if (!data) {
                return
            }

            const id = data?.id
            if (!id) {
                return
            }

            const options = quizz?.options 
            if (!options) {
                return
            }

            const option = options.find(option => option.id === id)

            setSelectedOption(option)
            
        } else {
            // Obtener el que se guardó anteriormente para mostrar que ya seleccionó.
            // En caso de que no haya seleccionado, mostrar mensaje de que no seleccionó alguno
            const tmpData = sessionStorage.getItem('eudnrlanrbaewq')

            if (tmpData) {
                const data = JSON.parse(tmpData)
                if (!data) {
                    return
                }

                const id = data?.id
                if (!id) {
                    return
                }

                const options = quizz?.options 
                if (!options) {
                    return
                }
    
                const option = options.find(option => option.id === id)
    
                setSelectedOption(option)
            } else {
                // Borrar el elemento guardado en sessionStorage
                sessionStorage.removeItem('eudnrlanrbaewq')
                return
            }
        }
    }, [quizz])

    const handleOptionClick = async (option) => {
        if (selectedOption !== null) return // ya respondió

        setSelectedOption(option)
        sessionStorage.setItem('eudnrlanrbaewq', JSON.stringify(option))

        if (option.isCorrect) {
            try {
                const response = await BLSubmitQuizzWithImageAndOptionsResponse(quizz.questionId)
                
                if (!response.success) {
                    console.warn('❌ Error al enviar respuesta:', response.message)
                }
            } catch (err) {
                console.error('❌ Error inesperado:', err)
            }
        }
    }

    if (!quizz || quizz.options === undefined || quizz.options.length === 0) {
        return <p className="QuizzWithImageAndOptions__Title">Cargando opciones...</p>
    }


    return (
        <div className="QuizzWithImageAndOptions">
            {/* Mostrar opciones SOLO si aún no ha respondido */}
            {selectedOption === null ? (
                <>
                    <p className="QuizzWithImageAndOptions__Title">Selecciona una opción</p>

                    {/* Cuando trae imágenes
                        <div className="QuizzWithImageAndOptions__Options">
                            {quizz.options.map((option, index) => (
                                <button key={index} className="QuizzWithImageAndOptions__Options__Buttons Btn__Adsl--RedOutline" onClick={() => handleOptionClick(option)}>
                                    {option.image && (
                                        option.image !== '' && (
                                            <img src={option.image} className='QuizzWithImageAndOptions__Options__Buttons__Image' />
                                        )
                                    )}
                                    <span className='QuizzWithImageAndOptions__Options__Buttons__Text'>{option.text}</span>
                                </button>
                            ))}
                        </div>
                    */}

                    <div className="QuizzWithImageAndOptions__Tiles">
                        {quizz.options.map((option, index) => (
                            <button key={index} className="QuizzWithImageAndOptions__Tiles__Buttons Btn__Adsl--RedOutline" onClick={() => handleOptionClick(option)}>
                                <span className='QuizzWithImageAndOptions__Tiles__Buttons__Text'>{option.text}</span>
                            </button>
                        ))}
                    </div>
                </>
            ) : (
                <div>
                    <p className="QuizzWithImageAndOptions__Title">Tú elegiste...</p>
                    {selectedOption.image && (
                        selectedOption.image !== '' && (
                            <img src={selectedOption.image} className='QuizzWithImageAndOptions__Image' />
                        )
                    )}
                    <p className="QuizzWithImageAndOptions__Title">{selectedOption.text}</p>
                </div>
            )}
        </div>
    )
}

export { QuizzWithImageAndOptions };